module.exports = __webpack_public_path__ + "img/光大.01d46c71.png";